export default "__VITE_ASSET__0e13bb26__"